import { Component, OnInit, ViewChildren, QueryList, ElementRef, ChangeDetectorRef} from '@angular/core';
import { saveAs } from 'file-saver';
import { DownloadFileService } from '../../../shared/services/download-file.service';
import { ApiService } from '../../../shared/services/api.service';
import { Urls } from '../../../utils/urls';
import { response } from 'express';
import { CommonDataService } from "@shared/services/common-data.service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-statuory',
  templateUrl: './statuory.component.html',
  styleUrls: ['./statuory.component.scss']
})
export class StatuoryComponent implements OnInit {
  activeId = 0;

  @ViewChildren('statutoryTab')
statutoryTabs!: QueryList<ElementRef>;

  topicList: any = [];

  statutoryList = [];

  subSection: any;

  section: any;

  months = [];

  year = [];

  isMobile = false;
  type: string = '';
  liveMessage = '';
  constructor(public downloadFileService: DownloadFileService,
    private apiService: ApiService,
    private router : Router,
    private cdr: ChangeDetectorRef,
    private commonDataService: CommonDataService,private activatedRoute: ActivatedRoute) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.type = params['type'] || '';
      });
     }

  ngOnInit() {
    this.scrollTop();
    this.getFiles();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getFiles = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.getPartnerFiles, { type: 'Disclosure' }).subscribe((response: any) => {
      if (response.data.typeList) {
        this.topicList = response.data.typeList;
        const requestedIndex = this.topicList.findIndex((item: any) => item.subType.toLowerCase() === this.type.toLowerCase());
        if(requestedIndex !== -1) {
          this.setActive(requestedIndex);
        } else if(this.topicList.length) {
          this.setActive(0);
        }
        this.commonDataService.loaderStatus.next(false);
      }
    });
  }

  // setActive = (id: number) => {
  //   this.activeId = id;
  //   this.router.navigate([], { queryParams: { type: this.topicList[id].subType } });
  // }
  setActive = (id: number) => {
  this.activeId = id;

  this.router.navigate([], {
    queryParams: {
      type: this.topicList[id].subType
    }
  });

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${this.topicList[id].subType} loaded.`;
  }, 100);
}

private focusTab(index: number): void {

  this.cdr.detectChanges();

  requestAnimationFrame(() => {
    this.statutoryTabs.get(index)?.nativeElement.focus();
  });

}

  viewFile = (path: string | URL | undefined) => {
    window.open(path, '_blank');
  }


  public downloadFile(path: string) {
    const fileName = path.split("/").pop();
    this.downloadFileService.export(path).subscribe(data => saveAs(data, fileName));
  }


  // toggleSection(item: any) {
  //   item.hide = !item.hide;
  // }
  toggleSection(item: any) {
  item.hide = !item.hide;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${item.topic} ${item.hide ? 'collapsed' : 'expanded'}.`;
  }, 100);
}

  onMobileView(status: boolean) {
    this.isMobile = status;
  }

  announceFilter(count: number) {
  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${count} files found.`;
  }, 100);
}

onVerticalKeydown(event: KeyboardEvent, index: number) {

  let nextIndex = index;

  switch (event.key) {

    case 'ArrowDown':
      event.preventDefault();
      nextIndex = Math.min(index + 1, this.topicList.length - 1);
      break;

    case 'ArrowUp':
      event.preventDefault();
      nextIndex = Math.max(index - 1, 0);
      break;

    case 'Home':
      event.preventDefault();
      nextIndex = 0;
      break;

    case 'End':
      event.preventDefault();
      nextIndex = this.topicList.length - 1;
      break;

    case 'Enter':
    case ' ':
      event.preventDefault();
      this.setActive(index);
      return;

    default:
      return;
  }

  this.setActive(nextIndex);
  this.focusTab(nextIndex);

}

}
